export enum GroupUserStatusEnum {
  Joined = 'joined',
  Requested = 'requested',
  Owner = 'owner',
}
